import {gql} from "apollo-boost";

export const LoginMutation = gql`
    mutation Affiliate($documentType: Int!, $documentNumber :String!, $password: String!, $deviceId: String!){
        externalAuth(
            documentType:$documentType,
            documentNumber:$documentNumber,
            password:$password,
            deviceId: $deviceId
        ){
            id
            name
            lastName
            returnUrl
        }
    }
`;